import { alpha } from '@mui/material'

import makePalette, { white } from './util'

/**
 * The one raised-surface tone: cards, dialogs, tables, the side nav, and
 * menus all share it (the light palette does the same via `white`). Change
 * this and every surface moves together.
 */
const surface = '#141414'

/**
 * The dark palette: pure neutral grays on a near-black canvas. Surfaces step
 * up in lightness as they come toward the viewer — body canvas darkest, cards
 * one step up, nav and menus one more — so depth reads through color instead
 * of shadows. `#2A2A2A` is the structural tone: hairline borders, tracks, and
 * raised controls sit there, separating containers without striping the UI.
 */
export default makePalette({
  action: {
    color: white,
    opacities: {
      active: 0.54,
      hover: 0.06,
      selected: 0.12,
      disabled: 0.3,
      focus: 0.12
    }
  },

  palette: {
    mode: 'dark',

    text: {
      primary: '#EDEDED',
      secondary: alpha(white, 0.62),
      disabled: alpha(white, 0.4)
    },

    background: {
      // Body canvas — near-black.
      layout: '#0C0C0C',
      default: '#101010',
      // #2A2A2A is the structural tone: hairlines, tracks, raised controls.
      paper: surface,
      navCard: surface
    },

    divider: '#2A2A2A',

    customColors: {
      main: '#E6E6E6',
      trackBg: '#2A2A2A',
      tableHeaderBg: '#1A1A1A'
    }
  }
})
